












































import { Component, Vue, Emit } from 'vue-property-decorator';

import CompanySelect from '@/components/base/CompanySelect.vue';
import { Company } from '@/models/session';
import { sessionStore } from '@/store/session';

import toast from '../toast';
import { ToastType } from '../toast/tost-type.enum';

@Component({
  components: {
    CompanySelect,
  },
})
export default class Header extends Vue {
  private toggleSidebar() {
    this.$emit('toggleSidebar');
  }

  private logout() {
    sessionStore.clear();
    this.$router.replace({
      name: 'login',
    });
    toast('Até a próxima!', ToastType.SUCESS);
  }

  get userImage() {
    return sessionStore.session.user.image;
  }

  get userName() {
    return sessionStore.session.user.name;
  }

  get userEmail() {
    return sessionStore.session.user.email;
  }

  get title() {
    return this.$route.meta.title;
  }

  @Emit()
  async onChangeSelectedCompany(company: Company) {
    this.$router.go(0);
    return company;
  }
}
